<template>
  <div class="nav-bar">
    <div>
      <div v-for="item in list" :key="item.label" @click="nav(item.path)" 
        :class="`item ${$route.path.includes(item.path) ? 'active' : ''}`">
        <p>{{item.label}}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [{
        label: '我的课程',
        path: '/lesson'
      }]
    }
  },
  methods: {
    nav(url) {
      this .$router.push(url)
    }
  }
}
</script>
<style lang="less" scoped>
.nav-bar {
  width: 100px;
  margin-top: 20px;
  flex-shrink:0; 
}
.item {
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #444;
  font-size: 14px;
  cursor: pointer;
}

.item:hover {
  color: #f06060;
}

.active {
  color: #13c29f;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/NavBar.vue